import _ from 'lodash'

import { objectKeysToSnakeCase } from '../../common/case-style-conversion'
import { fetchFromBackend } from '../../common/backend-client'

const ELEMENTS_PER_PAGE = 10
const normalize = filter => filter.toLowerCase().trim()

export async function queryAllTransfers(filters, lastLoadedElement) {
  const normalizedFilters = buildNormalizedFilters(filters)

  return await fetchFromBackend(`infrastructure/all_transfers`, {
    last_loaded_element: lastLoadedElement,
    page_size: ELEMENTS_PER_PAGE,
    filters: objectKeysToSnakeCase(normalizedFilters)
  })
}

export async function queryOrdersForTransfers(transferIds) {
  return await fetchFromBackend(`ordering/queries/orders-for-transfers-overview`, {
    transfer_ids: transferIds
  })
}

function buildNormalizedFilters(filters) {
  const normalizedFilters = _.clone(filters)
  normalizedFilters.from = normalize(filters.from)
  normalizedFilters.to = normalize(filters.to)
  normalizedFilters.transfer_code = normalize(filters.transferCode)
  normalizedFilters.reference_number = normalize(filters.referenceNumber)
  return normalizedFilters
}
